import type { ErrorEvent, Log } from '@sentry/core';

const sensitiveKey = /authorization|cookie|password|secret|token|(?:api|gateway).?key|signedTransaction|signedPayload|identityToken|(?:^|[._])body$|(?:^|[._])query(?:_?string)?$/i;

export function scrubDiagnostic(value: unknown, key = '', depth = 0): unknown {
  if (sensitiveKey.test(key)) return '[REDACTED]';
  if (depth > 12) return '[DEPTH LIMIT]';
  if (typeof value === 'string') return value
    .replace(/\b(Bearer|Basic)\s+[^\s"']+/gi, '$1 [REDACTED]')
    .replace(/(["']?(?:authorization|password|secret|[\w.-]*token|(?:api|gateway)[_-]?key)["']?\s*[:=]\s*)(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|[^\s,"'};]+)/gi, '$1[REDACTED]')
    .replace(/(https?:\/\/[^\s?#]+)[?#][^\s]*/g, '$1');
  if (Array.isArray(value)) return value.map((item) => scrubDiagnostic(item, '', depth + 1));
  if (value !== null && typeof value === 'object') return Object.fromEntries(
    Object.entries(value).map(([field, item]) => [field, scrubDiagnostic(item, field, depth + 1)]),
  );
  return value;
}

export function sanitizeEvent(event: ErrorEvent): ErrorEvent {
  if (event.request) {
    delete event.request.data;
    delete event.request.cookies;
    delete event.request.query_string;
  }
  // The scrubber retains the event's structure and primitive field types.
  return scrubDiagnostic(event) as ErrorEvent;
}

export function sanitizeLog(log: Log): Log {
  log.message = String(scrubDiagnostic(log.message));
  if (log.attributes) log.attributes = scrubDiagnostic(log.attributes) as Record<string, unknown>;
  return log;
}
